/** Store feature key of the ABCP closing-documents slice (REV-21376). */
export const CLOSING_DOCUMENT_FEATURE_KEY = 'abcpClosingDocuments';
